function throttleToAnimationFrame(callback) {
  let isCallbackPending = false;
  return () => {
    if (isCallbackPending) {
      return;
    }
    isCallbackPending = true;
    requestAnimationFrame(() => {
      isCallbackPending = false;
      callback();
    });
  };
}

export { throttleToAnimationFrame };
//# sourceMappingURL=dom.throttle-to-animation-frame.js.map
